var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvoPortalDashboardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 24C1.009 24 0 22.991 0 21.75V2.25C0 1.009 1.009 0 2.25 0H21.75C22.991 0 24 1.009 24 2.25V21.75C24 22.991 22.991 24 21.75 24H2.25ZM2.25 1.5C1.836 1.5 1.5 1.836 1.5 2.25V21.75C1.5 22.164 1.836 22.5 2.25 22.5H21.75C22.164 22.5 22.5 22.164 22.5 21.75V2.25C22.5 1.836 22.164 1.5 21.75 1.5H2.25Z",
    fill: "#00ACE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.25C13.086 14.25 12.75 13.914 12.75 13.5C12.75 13.086 13.086 12.75 13.5 12.75H19.5C19.914 12.75 20.25 13.086 20.25 13.5C20.25 13.914 19.914 14.25 19.5 14.25H13.5Z",
    fill: "#00ACE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.25C13.086 17.25 12.75 16.914 12.75 16.5C12.75 16.086 13.086 15.75 13.5 15.75H19.5C19.914 15.75 20.25 16.086 20.25 16.5C20.25 16.914 19.914 17.25 19.5 17.25H13.5Z",
    fill: "#00ACE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.25C13.086 20.25 12.75 19.914 12.75 19.5C12.75 19.086 13.086 18.75 13.5 18.75H17.25C17.664 18.75 18 19.086 18 19.5C18 19.914 17.664 20.25 17.25 20.25H13.5Z",
    fill: "#00ACE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.25C3.336 14.25 3 13.914 3 13.5C3 13.086 3.336 12.75 3.75 12.75H9.75C10.164 12.75 10.5 13.086 10.5 13.5C10.5 13.914 10.164 14.25 9.75 14.25H3.75Z",
    fill: "#00ACE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.25C3.336 17.25 3 16.914 3 16.5C3 16.086 3.336 15.75 3.75 15.75H9.75C10.164 15.75 10.5 16.086 10.5 16.5C10.5 16.914 10.164 17.25 9.75 17.25H3.75Z",
    fill: "#00ACE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 20.25C3.336 20.25 3 19.914 3 19.5C3 19.086 3.336 18.75 3.75 18.75H7.5C7.914 18.75 8.25 19.086 8.25 19.5C8.25 19.914 7.914 20.25 7.5 20.25H3.75Z",
    fill: "#00ACE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5C3.673 10.5 3 9.827 3 9V4.5C3 3.673 3.673 3 4.5 3H19.5C20.327 3 21 3.673 21 4.5V9C21 9.827 20.327 10.5 19.5 10.5H4.5ZM4.5 9H19.5V4.5H4.5V9Z",
    fill: "#00ACE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvoPortalDashboardIcon);
export default __webpack_public_path__ + "static/media/evo-portal-dashboard-icon.3e30df6331b64829613e2bc041b05347.svg";
export { ForwardRef as ReactComponent };